export default "__VITE_ASSET__BNsiedTv__"